<template>
  <el-form ref="tableForm" label-width="0px" :model="tableFormData" :disabled="disabled">
    <div class="text-right mb-10px">
      <el-button
        type="primary"
        @click.stop="$refs.dialog.showDialog = true"
        size="small"
        :disabled="disabled"
        >引用作业步骤</el-button
      >
      <el-button type="primary" @click.stop="createRow" size="small" :disabled="disabled"
        >新增</el-button
      >
    </div>
    <el-table max-height="400px" :data="tableData" border class="w-full" stripe>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="作业步骤" prop="jobStep" show-overflow-tooltip>
        <template slot="header">
          <span class="text-red-500">*</span>
          作业步骤
        </template>
        <template slot-scope="scope">
          <el-form-item
            class="mt-20px"
            label=""
            :prop="`${scope.row.id}jobStep`"
            :rules="[{ required: true, message: '作业步骤不能为空', trigger: ['blur', 'change'] }]"
          >
            <el-input
              type="textarea"
              maxlength="5000"
              show-word-limit
              :rows="3"
              :placeholder="disabled ? '' : '请输入作业步骤'"
              v-model="tableFormData[`${scope.row.id}jobStep`]"
              @change="(value) => tableChange(scope.row, value, 'jobStep')"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="危险源或潜在事件" prop="hiddenEvent" show-overflow-tooltip>
        <template slot="header">
          <span class="text-red-500">*</span>
          危险源或潜在事件
        </template>
        <template slot-scope="scope">
          <el-form-item
            class="mt-20px"
            label=""
            :prop="`${scope.row.id}hiddenEvent`"
            :rules="[
              { required: true, message: '危险源或潜在事件不能为空', trigger: ['blur', 'change'] },
            ]"
          >
            <el-input
              type="textarea"
              maxlength="5000"
              show-word-limit
              :rows="3"
              :placeholder="disabled ? '' : '请输入危险源或潜在事件'"
              v-model="tableFormData[`${scope.row.id}hiddenEvent`]"
              @change="(value) => tableChange(scope.row, value, 'hiddenEvent')"
            ></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="危险有害因素分类" prop="harmElementType" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input
            type="textarea"
            maxlength="5000"
            show-word-limit
            :rows="3"
            :placeholder="disabled ? '' : '请输入危险有害因素分类'"
            v-model="scope.row.harmElementType"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="可能导致事故类型" prop="accidentType" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input
            type="textarea"
            maxlength="5000"
            show-word-limit
            :rows="3"
            :placeholder="disabled ? '' : '请输入可能导致事故类型'"
            v-model="scope.row.accidentType"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="是否重点管控" prop="isFocusControl" show-overflow-tooltip width="200">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.isFocusControl"
            size="mini"
            :placeholder="disabled ? '' : '请输入是否重点管控'"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="财产伤亡预测" prop="assetsCasualtyPredict" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input
            maxlength="100"
            show-word-limit
            v-model="scope.row.assetsCasualtyPredict"
            :placeholder="disabled ? '' : '请输入财产伤亡预测'"
          >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="80">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click.stop="deleteRow(scope.row.id)"
            :disabled="disabled || tableData.length === 1"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <SelectCheckItems type="job" @handleOk="handleOk" :values="selectValues" ref="dialog" />
  </el-form>
</template>

<script>
import { JobSourcesDangerIdentifyApi } from '@wiz-api/double-prevention-management'
import utils from '@/components/safety/enumField/utils'
import SelectCheckItems from '../RiskIdentifyListTable/SelectCheckItems'

const jobSourcesDangerIdentifyApi = new JobSourcesDangerIdentifyApi()

const uuid = require('uuid')

export default {
  model: {
    prop: 'data',
    event: 'change',
  },
  name: 'equip-identify',
  components: {
    SelectCheckItems,
  },
  props: {
    taskId: {
      default: '',
    },
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      tableFormData: {},
      tableData: [],
      accidentTypeList: [],
      list: [],
    }
  },
  computed: {
    selectValues() {
      return this.tableData.map((item) => {
        return item.id
      })
    },
  },
  watch: {
    taskId: {
      immediate: true,
      handler(list) {
        this.getData()
      },
    },
  },
  created() {},
  mounted() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.AccidentType'],
      ['accidentTypeList'],
      this
    )
  },
  methods: {
    handleOk(values) {
      const data = JSON.parse(JSON.stringify(values)).filter((item) => {
        return (
          !this.tableData.length ||
          !this.tableData.find((i) => {
            return i.id === item.id
          })
        )
      })
      data.forEach((item) => {
        this.$set(this.tableFormData, `${item.id}jobStep`, item.jobStep)
        this.$set(this.tableFormData, `${item.id}hiddenEvent`, item.hiddenEvent)
        this.$set(this.tableFormData, `${item.id}harmElementType`, item.harmElementType)
      }, {})
      this.tableData = this.tableData.concat(data)
    },
    async getData() {
      // getJobActivityInfo
      if (!this.taskId) return
      const [err, res] = await jobSourcesDangerIdentifyApi.getJobList({
        id: this.taskId,
      })
      if (!err) {
        if (!res.length && !this.disabled) {
          this.createRow()
          return
        }
        this.tableData = res.map((item) => {
          item.isFocusControl =
            ['0', '1'].indexOf(item.isFocusControl) > -1
              ? item.isFocusControl * 1
              : item.isFocusControl
          return item
        })
        this.tableData.forEach((item) => {
          this.$set(this.tableFormData, `${item.id}jobStep`, item.jobStep)
          this.$set(this.tableFormData, `${item.id}hiddenEvent`, item.hiddenEvent)
          this.$set(this.tableFormData, `${item.id}harmElementType`, item.harmElementType)
        }, {})
      }
    },
    tableChange(row, value, filed) {
      row[filed] = value
    },
    validate() {
      let flag
      this.$refs.tableForm.validate((valid) => {
        flag = valid
      })
      return flag
    },
    createRow() {
      this.tableData.push({
        id: uuid(),
      })
    },
    deleteRow(id) {
      this.tableData = this.tableData.filter((item) => {
        return item.id !== id
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
